// ** React Imports
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useQueryClient } from 'react-query';

// ** Custom Components
import Avatar from '@components/avatar';

// ** Utils
import { isUserLoggedIn } from '@utils';

// ** Store & Actions
import { useDispatch } from 'react-redux';
import { handleLogout } from '@store/actions/auth';

// ** Third Party Components
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';
import { User, Power } from 'react-feather';
import { HiOutlineCurrencyDollar } from 'react-icons/hi';

import useJwt from '@src/auth/jwt/useJwt';

// ** Default Avatar Image
import defaultAvatar from '@src/assets/images/avatars/1.png';
import api from '@src/services/api';

const UserDropdown = () => {
  // ** Store Vars
  const history = useHistory();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  // ** State
  const [userData, setUserData] = useState(null);

  //* * ComponentDidMount
  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem('userData')));
    }
  }, []);

  //* * Vars
  const userAvatar = (userData && userData.avatar) || defaultAvatar;

  const handleClickLogout = async () => {
    api.post('logout', null, {
      headers: {
        Authorization: `Bearer ${useJwt.getToken()}`,
      },
    });

    dispatch(handleLogout());

    queryClient.removeQueries();

    history.push('/login');
  };

  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}
      >
        <div className="user-nav d-sm-flex d-none">
          <span className="company-name font-weight-bold">
            {(userData && userData.company && userData.company.companyName) ||
              'Loja'}
          </span>
          <span className="user-name mt-1 font-weight-bold">
            {(userData && userData.name) || 'John Doe'}
          </span>
          <span className="user-status text-capitalize">
            {(userData && userData.role) || 'Admin'}
          </span>
        </div>
        <Avatar img={userAvatar} imgHeight="40" imgWidth="40" status="online" />
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem tag={Link} to="/pages/account-settings">
          <User size={14} className="mr-75" />
          <span className="align-middle">Perfil</span>
        </DropdownItem>
        <DropdownItem
          tag={Link}
          to="/login"
          onClick={() => handleClickLogout()}
        >
          <Power size={14} className="mr-75" />
          <span className="align-middle">Sair</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
